import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { WhTaskStatusEditModal } from './components/wh-task-status-edit-modal';
import type { IWhTaskStatusEditComponentProps } from './types';

export const WhTaskStatusEditComponent = (props: IWhTaskStatusEditComponentProps) => {
  const { whTask } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<RocketOutlined />} onClick={handleOpen}>
        {t('trip:status')}
      </Button>
      <WhTaskStatusEditModal whTask={whTask} isOpen={isModalOpen} onClose={handleClose} />
    </>
  );
};

export const WhTaskStatusEdit = withRoleGuard<IWhTaskStatusEditComponentProps>(WhTaskStatusEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
  UserRole.storekeeper,
]);
